import { connect } from "react-redux";
import ListQueuesComponent from "../../Components/Queues/ListQueuesComponent";
const mapStateToProps = (state) => ({
    LICENCES: state.reducer.LICENCES,
    SCOPES_NAMES : state.reducer.SCOPES_NAMES,
    ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
    AGENTS : state.reducer.AGENTS,
    QUEUES:state.reducer.QUEUES,
        ROLES: state.reducer.ROLES,
    SCOPES: state.reducer.SCOPES
});
const mapDispatchToProps = (dispatch) => ({
   
});
 
export default connect(mapStateToProps, mapDispatchToProps)(ListQueuesComponent);